export default "__VITE_ASSET__DmD0kd26__"